import { useQuery } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";
import { QueryOptions } from "libs/reactQuery";

import { IWarehouse } from "../../warehouses.types";
import { requestGetWarehouses } from "./getWarehouses.request";

const useWarehouses = (
  options?: QueryOptions<IWarehouse[], ApiServiceError<ApiError>>,
) => {
  const { data, ...rest } = useQuery({
    queryKey: ["warehouses", "admin", "all"],
    queryFn: async () => await requestGetWarehouses(),
    ...options,
  });

  return { warehouses: data ?? [], ...rest };
};

export default useWarehouses;
